import { createPortal } from 'react-dom';
import { useEffect, useCallback, useRef, useMemo } from 'react';
import styled from 'styled-components';
import { HEFFALUMP } from 'HubStyleTokens/colors';
import { URANUS_LAYER } from 'HubStyleTokens/sizes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TD_ELEMENT_TYPE = 'TD';
const StyledTooltip = styled.div.withConfig({
  displayName: "CommentModeCursorTooltip__StyledTooltip",
  componentId: "sc-1yf8obl-0"
})(["display:none;z-index:", ";position:fixed;width:fit-content;padding:8px 16px;color:white;background-color:", ";border-radius:3px;"], URANUS_LAYER, HEFFALUMP);
const PopoverArrow = styled.div.withConfig({
  displayName: "CommentModeCursorTooltip__PopoverArrow",
  componentId: "sc-1yf8obl-1"
})(["background-color:", ";transform:rotate(45deg);width:16px;height:16px;position:absolute;left:-6px;top:12px;"], HEFFALUMP);
export default function CommentModeCursorTooltip({
  elementName = 'hubspot',
  portalClassnameWrapper
}) {
  const tooltipRef = useRef();
  const onMouseMove = useCallback(e => {
    const tooltip = tooltipRef.current;
    if (tooltip) {
      tooltip.style.left = `${e.pageX + 30 - window.scrollX}px`;
      tooltip.style.top = `${e.pageY - 20 - window.scrollY}px`;
      const target = e.target && e.target.nodeName === TD_ELEMENT_TYPE ? e.target.parentNode : e.target;
      tooltip.style.display = target && target.classList && target.classList.contains('commentable-area') && !target.classList.contains('commenting-commentable-area') ? 'block' : 'none';
    }
  }, []);
  const onMouseDown = useCallback(() => {
    const tooltip = tooltipRef.current;
    if (tooltip) {
      tooltip.style.display = 'none';
    }
  }, []);
  useEffect(() => {
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mousedown', onMouseDown);
    return () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mousedown', onMouseDown);
    };
  }, [onMouseDown, onMouseMove]);
  const appElement = document.getElementsByClassName(elementName);
  const cursorTooltip = useMemo(() => appElement.length > 0 ? /*#__PURE__*/createPortal(portalClassnameWrapper ? /*#__PURE__*/_jsx("div", {
    className: portalClassnameWrapper,
    children: /*#__PURE__*/_jsxs(StyledTooltip, {
      "data-test-id": "commentable-tooltip"
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      ,
      ref: tooltipRef,
      children: [/*#__PURE__*/_jsx(PopoverArrow, {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "collaborationSidebar.modals.commentMode.placeCommentTooltip"
      })]
    })
  }) : /*#__PURE__*/_jsxs(StyledTooltip, {
    "data-test-id": "commentable-tooltip"
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    ,
    ref: tooltipRef,
    children: [/*#__PURE__*/_jsx(PopoverArrow, {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "collaborationSidebar.modals.commentMode.placeCommentTooltip"
    })]
  }), appElement[0]) : null, [appElement, portalClassnameWrapper]);
  return cursorTooltip;
}